import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Angular Material imports
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CreateAssetComponent } from './create-asset/create-asset.component';
import { MatSelectModule } from '@angular/material/select';
import { AnalyticsPopupComponent } from './analytics-popup/analytics-popup.component';
import { EraseMetadataComponent } from './erase-metadata/erase-metadata.component';
import { MetadataComponent } from './metadata/metadata.component';
import { CapabilityComponent } from './capability/capability.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FaqComponent } from './faq/faq.component';
import { SendReportPopupComponent } from './send-report-popup/send-report-popup.component';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    CreateAssetComponent,
    AnalyticsPopupComponent,
    EraseMetadataComponent,
    MetadataComponent,
    CapabilityComponent,
    FaqComponent,
    SendReportPopupComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatChipsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule
  ],
  exports: [
    SendReportPopupComponent
  ]
})
export class MatchvisionModalsModule { }
